/** Optimized dimensions for the menu item modal hero (keep in sync with MenuItemModal nuxt-img). */
export const MENU_ITEM_MODAL_IMAGE = {
  width: 576,
  height: 210,
  quality: 80,
  format: 'webp' as const
}
